export const kiplePaymentCodes = [
    { code: "AFBB", label: "AFFIN Bank", },
    { code: "ALBB", label: "Alliance Bank", },
    { code: "AMBB", label: "AMBank", },
    { code: "BIBB", label: "Bank Islam", },
    { code: "BKRB", label: "Bank Kerjasama Rakyat", },
    { code: "BMMB", label: "Bank Muamalat", },
    { code: "BSNB", label: "Bank Simpanan Nasional", },
    { code: "CIMB", label: "CIMB Clicks", },
    { code: "HLBB", label: "Hong Leong", },
    { code: "HSBC", label: "HSBC", },
    { code: "KFHB", label: "Kuwait Finance House", },
    { code: "MYBB", label: "Maybank2u", },
    { code: "MYBB2E", label: "Maybank2e", },
    { code: "OCBC", label: "OCBC Bank", },
    { code: "PUBB", label: "Public Bank", },
    { code: "RHBB", label: "RHB Now", },
    { code: "SCBB", label: "Standard Chartered", },
    { code: "UOBB", label: "United Overseas Bank", },
    { code: "DSBB", label: "DEUTSCHE BANK", },
]